import * as Contentstack from 'contentstack';
const Stack = Contentstack.Stack(
    process.env.REACT_APP_API_KEY,
    process.env.REACT_APP_DELIVERY_TOKEN,
    process.env.REACT_APP_ENVIRONMENT
);

export const getHomeContent = (store) => {
    let home = {
        home_status: 'INITIAL',
    };
    home.home_status = 'LOADING';
    store.setState({ home });
    try {
        //Home page query
        const HomeQuery = Stack.ContentType('home').Query();
        HomeQuery.includeReference([
            'home_hero_image',
            'home_capabilities',
            'value_of_ethanol',
            'safety_and_work',
            'get_in_touch',
        ])
            .toJSON()
            .find()
            .then(
                function success(result) {
                    const homeData = result[0];
                    const isContentEmpty = homeData.length == 0;
                    home = isContentEmpty ? home : homeData[0];
                    home.home_status = isContentEmpty ? 'EMPTY' : 'SUCCESS';
                    store.setState({
                        home,
                    });
                },
                function error(err) {
                    const isError404 =
                        err.response && err.response.status === 404;
                    const status = isError404 ? 'NOT_FOUND' : 'ERROR';
                    home.home_status = status;
                    store.setState({ home });
                }
            );
    } catch (error) {
        store.setState({ status: 'ERROR`' });
    }
};
